import React from 'react';
import ReactDOM from 'react-dom/client';
import { AppRouter } from './AppRouter';
import './index.css';
ReactDOM.createRoot(document.getElementById('root')!).render(<React.StrictMode data-id="element-123" data-mp="1wcxtln6654es">
    <AppRouter data-id="element-124" data-mp="21ah5igfe953k" />
  </React.StrictMode>);